import { AxiosInstance, AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { mergeDeepRight } from 'ramda';
import secureLocalStorage from 'react-secure-storage';

export const LOCAL_STORAGE_AUTH_TOKEN_KEY = 'token';
export const getAuthToken = (): string | null => secureLocalStorage.getItem('token') as string | null;
export const maybeSetAuthHeaders = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  const token = getAuthToken();
  const headers = token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};

  const authHeaders = { headers };
  return mergeDeepRight(config, authHeaders);
};

export const handleSuccess = async (response: AxiosResponse) => response;

const makeUrlRoute = (endpoint: string | string[]) => {
  const route = Array.isArray(endpoint) ? endpoint.join('/') : endpoint;
  return `/${route}/`;
};

export const makeUrl = (base: string, endpoint?: string | string[]) => {
  const route = endpoint ? makeUrlRoute(endpoint) : '';
  return `/${base}${route}/`;
};

export const callApiInstance = (instance: AxiosInstance) => (config: AxiosRequestConfig) => instance.request(config);
